import { Apartment, Traveller } from "@/types";
import { SkiPassAgeLevels } from "@/types/skipass";
import { Trip } from "@/types/trip";

export const defaultAgeLevels: SkiPassAgeLevels = {
  child: { min: 0, max: 11, label: 'Children' },
  youth: { min: 12, max: 17, label: 'Youth' },
  adult: { min: 18, max: 65, label: 'Adults' },
  senior: { min: 66, max: 150, label: 'Seniors' }
};

export const defaultTransportationOptions = [
  {
    id: 'private-car',
    name: 'Private Car',
    type: 'individual',
    pricePerPerson: 0
  },
  {
    id: 'group-bus',
    name: 'Group Bus',
    type: 'group',
    pricePerPerson: 80
  },
  {
    id: 'train',
    name: 'Train',
    type: 'public',
    pricePerPerson: 120
  }
];

const defaultApartmentTypes = [
  {
    id: 'apartment-type-1',
    name: '4 Pax Studio',
    priceRules: [
      { occupancy: 1, pricePerPersonPerWeek: 600 },
      { occupancy: 2, pricePerPersonPerWeek: 450 },
      { occupancy: 3, pricePerPersonPerWeek: 400 },
      { occupancy: 4, pricePerPersonPerWeek: 350 }
    ]
  },
  {
    id: 'apartment-type-2',
    name: '2 Room Apartment',
    priceRules: [
      { occupancy: 1, pricePerPersonPerWeek: 900 },
      { occupancy: 2, pricePerPersonPerWeek: 750 },
      { occupancy: 3, pricePerPersonPerWeek: 680 },
      { occupancy: 4, pricePerPersonPerWeek: 620 },
      { occupancy: 5, pricePerPersonPerWeek: 580 },
      { occupancy: 6, pricePerPersonPerWeek: 540 }
    ]
  }
];

const defaultSkiPasses = [
  {
    id: 'day-pass',
    name: 'Daily Pass',
    type: 'daily' as const,
    validDays: 1,
    adultPrice: 65,
    youthPrice: 45,
    seniorPrice: 55,
    childPrice: 25
  },
  {
    id: 'week-pass',
    name: '7 days Pass',
    type: 'multi-day' as const,
    validDays: 7,
    adultPrice: 350,
    youthPrice: 245,
    seniorPrice: 295,
    childPrice: 150
  }
];

export const defaultTrip: Trip = {
  id: '1',
  name: 'Alpine Adventure 2024',
  destination: 'Zermatt, Switzerland',
  startDate: '2024-02-15',
  endDate: '2024-02-22',
  isSignUpOpen: true,
  defaultMembershipFee: 35,
  skiPassAgeLevels: defaultAgeLevels,
  skiPasses: defaultSkiPasses,
  apartmentTypes: defaultApartmentTypes,
  transportationOptions: defaultTransportationOptions,
  statistics: {
    travellers: {
      total: 2,
      totalSkiClubMembers: 1,
    },
    apartments: {
      total: 2,
      totalNumberOfBeds: 10,
      totalOccupancy: 2,
    },
    skiPasses: {
      total: 2,
    },
  }
};

export const defaultTravellers: Traveller[] = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john@example.com',
    phone: '+49 176 123 4567',
    address: { street: '123 Main St', city: 'Munich', postalCode: '80331', country: 'Germany' },
    dateOfBirth: '1985-03-15',
    isSkiClubMember: true,
    skiPassType: 'week-pass',
    apartmentId: 'apt-1',
    transportationType: 'group-bus',
    status: 'confirmed'
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    phone: '+49 176 987 6543',
    address: { street: '456 Oak Ave', city: 'Berlin', postalCode: '10115', country: 'Germany' },
    dateOfBirth: '1990-07-22',
    isSkiClubMember: false,
    membershipFee: 30,
    skiPassType: 'week-pass',
    apartmentId: 'apt-1',
    transportationType: 'private-car',
    status: 'confirmed'
  }
]

export const defaultApartments: Apartment[] = [
  {
    id: 'apt-1',
    name: 'Alpine View Studio',
    class: 'standard',
    maxOccupancy: 4,
    currentOccupancy: 2,
    apartmentTypeId: 'apartment-type-1',
    amenities: ['Kitchen', 'Balcony', 'WiFi'],
    billStatus: 'not_sent',
    isPaid: false
  },
  {
    id: 'apt-2',
    name: 'Matterhorn Suite',
    class: 'premium',
    maxOccupancy: 6,
    currentOccupancy: 0,
    apartmentTypeId: 'apartment-type-2',
    amenities: ['Full Kitchen', 'Fireplace', 'Mountain View', 'Balcony', 'WiFi'],
    billStatus: 'not_sent',
    isPaid: false
  }
]
